import {NgModule} from '@angular/core';
import {SharedModule} from "../../common/shared.module";
import {SharedMiniModule} from "../../common/shared-mini.module";
import StationLoaderComponent from "./station-loader/station-loader.component";
import {StationAddPlayerComponent} from "./station-add-player/station-add-player.component";
import {StationRegCodeComponent} from "./station-add-player/station-reg-code/station-reg-code.component";

@NgModule({
    imports: [
        SharedModule,
        SharedMiniModule,
    ],
    declarations: [
        StationLoaderComponent,
        StationAddPlayerComponent,
        StationRegCodeComponent
    ]
})
export class StationsModule {
}
